const FilterDropdown = ({ label, options, value, onChange }) => {
    return (
      <div className="relative">
        <select
          value={value}
          onChange={onChange}
          className="appearance-none bg-[#2A2A2A] border border-[#3A3A3A] rounded-xl px-4 py-3 pr-8 text-[#FFFFFF] focus:outline-none focus:border-[#B4E50D] focus:ring-2 focus:ring-[#B4E50D] focus:ring-opacity-20 transition-all duration-200 w-full"
        >
          <option value="" className="bg-[#2A2A2A] text-[#B0B0B0]">{label}</option>
          {options.map((option) => (
            <option key={option} value={option} className="bg-[#2A2A2A] text-[#FFFFFF]">
              {option}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
          <svg className="w-4 h-4 text-[#B0B0B0]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    );
  };
  
  export default FilterDropdown;